import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { CommonApiData } from '../CommonComponents/EnvConfig';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, FormButton, ImportButton, InputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const PinCodeMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [formData, setFormData] = useState({
        pinCodeID: '',
        pinCode: '',
        cityName: '',
        stateName: '',
        isActive: true
    });

    const GetPinCodeData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowPinCodeMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        } if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async () => {
        setFormData({
            pinCodeID: '',
            pinCode: '',
            cityName: '',
            stateName: '',
            isActive: true
        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdatePinCodeMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditPinCodeMaster`, { pinCodeID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeletePinCodeMaster`, { pinCodeID: id }, GetPinCodeData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        GetPinCodeData(value);
    };

    const DownloadFormat = async () => {
        await DownloadFileAtURL('PinCodeMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'PinCodeMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            pinCode: '',

        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("PinCode","CityName", "StateName", "IsActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdatePinCodeMaster', ImportData, Data2, GetPinCodeData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }

    useEffect(() => {
        GetPinCodeData()
        document.title = 'Pin Code Master'
        inputrefs.current['txtPinCode'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Pin Code Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                            <div className='row'>
                                <InputBox
                                    id="txtPinCode"
                                    type="text"
                                    label='Pin Code'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    onChange={(e) => setFormData({ ...formData, pinCode: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtCity'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='Pin Code'
                                    name='PinCode'
                                    value={formData.pinCode}
                                    maxLength='6'
                                    required={true }
                                />
                                <InputBox
                                    id="txtCity"
                                    type="text"
                                    placeholder="City Name"
                                    label={'City Name'}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    onChange={(e) => setFormData({ ...formData, cityName: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtState'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    name='CityName'
                                    value={formData.cityName}
                                    maxLength='100'
                                    required={true}
                                />
                                <InputBox
                                    type="text"
                                    id="txtState"
                                    placeholder="State Name"
                                    label={'State Name'}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    onChange={(e) => setFormData({ ...formData, stateName: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    name='StateName'
                                    value={formData.stateName}
                                    maxLength='100'
                                    required={true}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />
                            </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PinCode,CityName,StateName,Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                handleExport={() => handleDownloadExcel(`/api/Master/ShowPinCodeMaster`, filterData, 'PinCodeMaster')}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <Table
                handleDelete={handleDelete}
                handleEdit={handleEditData}
                loading={isLoading}
                PageName={'PinCodeMaster'}
                handleFilter={() => {
                    GetPinCodeData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default PinCodeMaster;